import styled from "styled-components";
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import customCheckboxStyles from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.js";

const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #eeeeee;
  /* margin: 0 0.5rem; */
  &:last-child {
    border-bottom: 2px solid lightgray;
  }
`;

const InfoContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
`;

const ColumnStyled = styled.div`
  padding: 3px;
  text-align: center;
  justify-content: ${(props) =>
    props.position ? `${props.position}` : "center"};
  font-size: 12px;
  /* width: 25%; */
  width: ${(props) => (props.width ? `${props.width}%` : "10%")};
  word-wrap: break-all;
  display: flex;
  align-items: center;
  color: #3c4858;
`;

const styles = (theme) => ({
  ...selectStyles,
  ...customCheckboxStyles,
});

export { Row, ColumnStyled, InfoContainerStyled, styles };
